var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 70,
    viewBox: "0 0 54 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9987 8.33333V2.36667C26.9987 0.866667 25.1987 0.133333 24.1654 1.2L14.832 10.5C14.1654 11.1667 14.1654 12.2 14.832 12.8667L24.132 22.1667C25.1987 23.2 26.9987 22.4667 26.9987 20.9667V15C38.032 15 46.9987 23.9667 46.9987 35C46.9987 37.6333 46.4987 40.2 45.532 42.5C45.032 43.7 45.3987 45.0667 46.2987 45.9667C47.9987 47.6667 50.8654 47.0667 51.7654 44.8333C52.9987 41.8 53.6654 38.4667 53.6654 35C53.6654 20.2667 41.732 8.33333 26.9987 8.33333ZM26.9987 55C15.9654 55 6.9987 46.0333 6.9987 35C6.9987 32.3667 7.4987 29.8 8.46536 27.5C8.96536 26.3 8.5987 24.9333 7.6987 24.0333C5.9987 22.3333 3.13203 22.9333 2.23203 25.1667C0.998698 28.2 0.332031 31.5333 0.332031 35C0.332031 49.7333 12.2654 61.6667 26.9987 61.6667V67.6333C26.9987 69.1333 28.7987 69.8667 29.832 68.8L39.132 59.5C39.7987 58.8333 39.7987 57.8 39.132 57.1333L29.832 47.8333C28.7987 46.8 26.9987 47.5333 26.9987 49.0333V55Z",
    fill: "#7E7892"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessing);
export default __webpack_public_path__ + "static/media/processing.11f39e844200d3032cbb033008d1968c.svg";
export { ForwardRef as ReactComponent };